module.exports = __webpack_public_path__ + "static/img/icps_login.1bd149f2.png";